import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormatterRoutingModule } from './formatter-routing.module';
import {FormatterService} from './formatter.service';

@NgModule({
  imports: [
    CommonModule,
    FormatterRoutingModule
  ],
  declarations: [],
  providers: [FormatterService]
})
export class FormatterModule { }



// WEBPACK FOOTER //
// ./src/app/resources-modules/formatter/formatter.module.ts